exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ToggleButton-module__wrapper___3_69o{background-color:#f4f4f4;border-radius:999px;padding:10px 15px;display:grid;grid-auto-flow:column;gap:50px;position:relative;cursor:pointer}.ToggleButton-module__wrapper___3_69o p{min-width:120px;text-align:center;z-index:2;color:#707070;transition:all .2s ease-in-out}.ToggleButton-module__wrapper___3_69o p.ToggleButton-module__active___3Kg9P{color:#fff}.ToggleButton-module__wrapper___3_69o .ToggleButton-module__slider___OBOhn{position:absolute;width:50%;height:100%;background-color:#1368e5;border-radius:999px}", ""]);

// exports
exports.locals = {
	"wrapper": "ToggleButton-module__wrapper___3_69o",
	"active": "ToggleButton-module__active___3Kg9P",
	"slider": "ToggleButton-module__slider___OBOhn"
};